<template>
  <div>
    <DownloadModal 
      :activeModal="downloadActive" 
      :expiredStatus="expiredStatus" 
      :closeModal="closeDialog"
      :fileLink="fileLink"
      :isIframe="true"
    />
  </div>
</template>

<script>
import Users from './../../../apiClient/Users'
import { mapActions, mapGetters } from 'vuex'
import DownloadModal from './../../Home/components/Modals/DownloadModal.vue'

export default {
  name: 'IframeDocumentDownload',
  components: {
    DownloadModal
  },
  data() {
    return {
      user: '',
      downloadActive: false,
      expiredStatus: false,
      fileLink: ''
    }
  },
  async created() {
    this.user = new Users()
    
    if (this.factoryCurrentCompanyIsAvailable()) {
      this.checkDownloadAvailable()
    } else {
      const employee = this.findFactoryCompanyIsAvailable()
      if (employee) {
        setTimeout(() => {
          this.setParamLoginFactory('')
          this.checkDownloadAvailable()
        }, 3000)
      }
    }
  },
  methods: {
    ...mapActions({
      setParamLoginFactory: 'auth/setParamLoginFactory',
    }),
    closeDialog() {
      this.setParamLoginFactory('')
      this.downloadActive = false
    },
    factoryCurrentCompanyIsAvailable() {
      const factory = parseInt(this.getFactoryStringParam, 10)
      const id = this.$store.getters.getUser.empresa.id
      return factory === id
    },
    findFactoryCompanyIsAvailable() {
      return find(this.$store.getters.getUsersRelated, user => {
        return user.empresa.id === parseInt(this.getFactoryStringParam, 10)
      })
    },
    checkDownloadAvailable() {
      this.user
        .getDownloadAvailable()
        .then(responseAvailable => {
          if (responseAvailable.data.data.ready) {
            this.user
              .getDownloadFile()
              .then(responseBinary => {
                this.downloadActive = true
                this.expiredStatus = false
                this.fileLink = responseBinary.data.data.link
              })
              .catch(() => {
                this.downloadActive = true
                this.expiredStatus = true
              })
          }
        })
        .catch((e) => {
          this.downloadActive = true
          this.expiredStatus = true
        })
    }
  },
  computed: {
    ...mapGetters({
      getFactoryStringParam: 'auth/getFactoryStringParam'
    })
  }
}
</script>